/* The frame hero is server-rendered; the third-party builder starts on demand. */
(() => {
  "use strict";
  if (window.GrowplayBuilderLoader) return;

  function mount() {
    const template = document.querySelector("template[data-gp-builder-template]");
    if (!template) return false;
    const fragment = template.content.cloneNode(true);
    const scripts = [...fragment.querySelectorAll("script")];
    // Mark scripts inert before inserting the complete host markup. Restore only
    // executable scripts; application/json nodes are data, not code.
    const executable = scripts.filter(
      (script) =>
        !script.type ||
        /^(?:text|application)\/javascript$/.test(script.type) ||
        script.type === "module",
    );
    executable.forEach((script) => {
      script.dataset.gpOriginalType = script.type;
      script.type = "text/gp-inert";
    });
    template.replaceWith(fragment);
    executable.forEach((original) => {
      const script = document.createElement("script");
      [...original.attributes].forEach(({ name, value }) => {
        if (!["type", "data-gp-original-type", "defer"].includes(name))
          script.setAttribute(name, value);
      });
      if (original.dataset.gpOriginalType) script.type = original.dataset.gpOriginalType;
      if (original.src) script.async = false;
      script.textContent = original.textContent;
      original.replaceWith(script);
    });
    document.dispatchEvent(new CustomEvent("gp:builder-mounted"));
    return true;
  }

  window.GrowplayBuilderLoader = { mount };
  // Saved configurations are explicit builder entry points.
  const params = new URLSearchParams(location.search);
  if (params.has("configid") || params.has("configId")) mount();
})();
